import { AF_AUCTION_MODEL_CONFIG, AF_AUCTION_MODEL_CONFIG_ID, AF_BID_MODEL_CONFIG, AF_BID_MODEL_CONFIG_ID, AF_FILE_MODEL_CONFIG, AF_FILE_MODEL_CONFIG_ID, AF_IMAGE_MODEL_CONFIG, AF_IMAGE_MODEL_CONFIG_ID, AF_STOCK_MODEL_CONFIG, AF_STOCK_MODEL_CONFIG_ID } from "@pattonair/auction-framework";
import { MfModelConfig, MfModelsConfig } from "@pattonair/material-framework";
import { AUC_USER_APPROVED_MODEL_CONFIG, AUC_USER_APPROVED_MODEL_CONFIG_ID } from "./user.approved.model.config";
import { AUC_USER_MODEL_CONFIG, AUC_USER_MODEL_CONFIG_ID } from "./user.model.config";

export type AucModelsConfig = MfModelsConfig & {
  [AF_AUCTION_MODEL_CONFIG_ID]: MfModelConfig;
  [AF_AUCTION_MODEL_CONFIG_ID]: MfModelConfig;
  [AF_BID_MODEL_CONFIG_ID]: MfModelConfig;
  [AF_IMAGE_MODEL_CONFIG_ID]: MfModelConfig;
  [AF_STOCK_MODEL_CONFIG_ID]: MfModelConfig;
  [AF_FILE_MODEL_CONFIG_ID]: MfModelConfig;
  [AUC_USER_MODEL_CONFIG_ID]: MfModelConfig;
  [AUC_USER_APPROVED_MODEL_CONFIG_ID]: MfModelConfig;
}

export const AUC_MODEL_CONFIG: AucModelsConfig = {
  [AF_AUCTION_MODEL_CONFIG_ID]: AF_AUCTION_MODEL_CONFIG,
  [AF_BID_MODEL_CONFIG_ID]: AF_BID_MODEL_CONFIG,
  [AF_IMAGE_MODEL_CONFIG_ID]: AF_IMAGE_MODEL_CONFIG,
  [AF_STOCK_MODEL_CONFIG_ID]: AF_STOCK_MODEL_CONFIG,
  [AF_FILE_MODEL_CONFIG_ID]: AF_FILE_MODEL_CONFIG,
  [AUC_USER_MODEL_CONFIG_ID]: AUC_USER_MODEL_CONFIG,
  [AUC_USER_APPROVED_MODEL_CONFIG_ID]: AUC_USER_APPROVED_MODEL_CONFIG,
} as const;